// extracted by mini-css-extract-plugin
module.exports = {"text":"CreditCourtesy_text__3NhKx","label":"CreditCourtesy_label__1-o7o","root":"CreditCourtesy_root__1VmhY","editContainer":"CreditCourtesy_editContainer__33N9C"};